/**
 * The signed-in person's profile, for every screen that used to read a
 * constant.
 *
 * `useProfile()` never returns undefined: until the row has loaded (or when
 * the server has none) it is `DEFAULT_PROFILE`, which has no home — so a
 * screen drawing "near you" from it draws nothing rather than something
 * wrong. The query is `['profile', uid]` in the persisted cache
 * (`store.ts` keys that cache per user, U0.4), so a returning phone paints
 * with the real profile on the first frame.
 *
 * Call it once per screen and thread the value down, as `useAffinity` is;
 * the pure functions in `reach.ts`, `entries.ts` and `today.ts` take the
 * value, not the hook, so `npm test` can see them.
 */
import { useProfileRow } from './queries'
import { DEFAULT_PROFILE, type Profile } from './profileDefaults'

export {
  DEFAULT_PROFILE, homePoint, mergeProfile, secondHomeAirports, secondHomeCountry, secondHomeLabel, secondHomeOf,
  type Profile, type ProfilePatch, type SecondHome,
} from './profileDefaults'

export function useProfile(): Profile {
  return useProfileRow().data ?? DEFAULT_PROFILE
}
